omadapp.interfaces.animable = {
	isAnimable:true,
	parar:function () {
		trace (this)
	},
	cancelarAnimacion:function () {
		trace ("cancelarAnimacion")
		trace (this)
	},
}